"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTH_ENDPOINT = exports.CLAIM_TYPES = exports.RECOVERY_METHODS = exports.PASSWORDLESS_LOGIN_TYPES = exports.USERNAME_TYPES = void 0;
const USERNAME_TYPES = {
  cpf: 'cpf',
  email: 'email'
};
exports.USERNAME_TYPES = USERNAME_TYPES;
const PASSWORDLESS_LOGIN_TYPES = {
  cellphone: 'CELLPHONE_OTP',
  email: 'EMAIL_OTP'
};
exports.PASSWORDLESS_LOGIN_TYPES = PASSWORDLESS_LOGIN_TYPES;
const RECOVERY_METHODS = {
  cellphone: 'CELLPHONE',
  email: 'EMAIL'
};
exports.RECOVERY_METHODS = RECOVERY_METHODS;
const CLAIM_TYPES = {
  cellphone: 'CELLPHONE',
  email: 'EMAIL'
};
exports.CLAIM_TYPES = CLAIM_TYPES;
const AUTH_ENDPOINT = {
  accountInformation: 'accounts/current',
  loginPassword: 'oauth/token',
  passwordResets: 'password-resets',
  requestPasswordlessLogin: 'passwordless-login',
  smartSignin: 'accounts/smart-sign-in',
  createAccount: 'accounts',
  createCustomer: 'accounts/current/customer',
  requestClaimAddition: 'accounts/authentication-claims',
  verifyClaim: 'accounts/authentication-claims/verify',
  resendVerificationCode: 'accounts/authentication-claims/resend'
};
exports.AUTH_ENDPOINT = AUTH_ENDPOINT;